import { differenceInDays } from 'date-fns';
import { Badge } from '@/components/ui/badge';

type Props = {
  expiresAt: string | null;
};

export const BagDeadlineBadge = ({ expiresAt }: Props) => {
  if (!expiresAt) return null;

  const days = differenceInDays(new Date(expiresAt), new Date());

  if (days >= 0) {
    return (
      <Badge className="bg-blue-100 text-blue-700 border-blue-200 hover:bg-blue-100">
        prazo: {days} dias
      </Badge>
    );
  }

  return (
    <Badge className="bg-red-100 text-red-700 border-red-200 hover:bg-red-100">
      PRAZO VENCIDO há {Math.abs(days)} dias
    </Badge>
  );
};
